import { API_CONFIG, API_ENDPOINTS, authFetch, getHeadersWithOrg } from './client';
import { ErrorResponse } from '../../types';

export interface PublishFromMapResponse {
  status: string;
  ditamap_guid: string;
}

/**
 * Error thrown by {@link publishFromMap} that carries the HTTP status code so
 * the caller can distinguish a 409 (map already publishing) from other errors.
 */
export class PublishError extends Error {
  status: number;
  constructor(status: number, message: string) {
    super(message);
    this.name = 'PublishError';
    this.status = status;
  }
}

/**
 * Trigger an on-demand publish of all files reachable from a ditamap.
 * The backend runs the actual S3 writes in a background task and returns 202.
 */
export async function publishFromMap(
  siteId: string,
  ditamapGuid: string,
  contextRoot: string,
  geoEnabled: boolean = true,
  updatePublishedPath: boolean = true,
): Promise<PublishFromMapResponse> {
  const url = `${API_CONFIG.BASE_URL}${API_ENDPOINTS.PUBLISH(siteId)}`;
  const response = await authFetch(url, {
    method: 'POST',
    headers: getHeadersWithOrg(),
    body: JSON.stringify({
      ditamap_asset_guid: ditamapGuid,
      published_context_root: contextRoot,
      geo_enabled: geoEnabled,
      update_published_path: updatePublishedPath,
    }),
  });

  if (!response.ok) {
    const errorData: ErrorResponse = await response
      .json()
      .catch(() => ({ error: `HTTP ${response.status}` }));
    const message =
      errorData.detail || errorData.error || `Publish failed: ${response.status}`;
    throw new PublishError(response.status, message);
  }

  return response.json();
}
